export enum recruiterReceiptPostTypes {
    FETCH_RECRUITER_RECEIPT_POST_SUCCESS = "FETCH_RECRUITER_RECEIPT_POST_SUCCESS",
    FETCH_RECRUITER_RECEIPT_POST_FAILURE = "FETCH_RECRUITER_RECEIPT_POST_FAILURE",
    FETCH_RECRUITER_RECEIPT_POST_REQUEST = "FETCH_RECRUITER_RECEIPT_POST_REQUEST"
  }